import { post, patch } from "./apiService";
import { ApiUrls } from "./ApiUrls";

// Helpers
import { getLocalStorage } from "../../helpers/utils";

// Interfaces
import {
  LoginPayload,
  ForgotPasswordPayload,
  ResetPasswordPayload,
} from "../../interfaces";

export const login = async (data: LoginPayload) => {
  try {
    const res = await post(ApiUrls.authModule.login, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const forgotPassword = async (data: ForgotPasswordPayload) => {
  try {
    const res = await post(ApiUrls.authModule.forgotPassword, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const resetPassword = async (data: ResetPasswordPayload) => {
  try {
    const res = await post(ApiUrls.authModule.resetPassword, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const logout = async () => {
  try {
    const token = getLocalStorage("token");
    const res = await post(ApiUrls.authModule.logout, { token });
    sessionStorage.removeItem("upload_consent");
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const resendOTP = async (data: ForgotPasswordPayload) => {
  try {
    const res = await post(ApiUrls.authModule.resendOTP, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const acceptTerms = async (
  policy_version: string = "v1.0",
  form_type: string = "privacy_and_terms",
) => {
  try {
    const res = await patch(
      `${ApiUrls.authModule.acceptTerms}?form_type=${form_type}&policy_version=${policy_version}`,
      {},
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
